import type { Icon } from './icon-list.type';

export type InitialsAvatar = {
  type: 'initials';
  light: boolean;
  initials: string;
  color?: string;
};

export type ImageAvatar = {
  type: 'image';
  src: string;
};

export type IconAvatar = {
  type: 'icon';
  icon: Icon;
  color?: string;
  bg_color?: string;
};
export type Avatar = InitialsAvatar | ImageAvatar | IconAvatar;

export const DEFAULT_ICON_AVATAR: Avatar = {
  type: 'icon',
  icon: 'user',
};

export const DEFAULT_INITIALS_AVATAR: Avatar = {
  type: 'initials',
  initials: '',
  light: true,
  color: 'var(--fill-neutral-expressive)',
};
